module.exports = __webpack_public_path__ + "img/store-speed-0_19.275f91f2.svg";